import * as Yup from 'yup';

export default Yup
  .string()
  .trim()
  .max(125, 'Observação muito longa, não deve exceder 125 caractéres');
